import React from "react";
import { NavigateFunction } from "react-router-dom";
import ItemsIcon from "../../../../../images/common/item-grey.svg";
import EditIcon from "../../../../../images/products/edit-blue.svg";
import { RelatedAddOnsGridModel } from "../models";
import {
  CustomButton,
  ITableHeaders,
  TableWithHeaderButtons,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import PlaceholderSmallerGrid from "./PlaceholderSmallerGrid";
import TableGrid from "./TableGrid";
import { RolesAndPermissionStore } from "../store";

type IProps = {
  navigate: NavigateFunction;
  items: RelatedAddOnsGridModel[];
  rolesAndPermissionStore: RolesAndPermissionStore;
};
const RelatedAddOnsGrid: React.FC<IProps> = ({
  items,
  navigate,
  rolesAndPermissionStore,
}) => {
  const getTitle = (title: string) => {
    switch (title) {
      case "Included":
        return (
          <CustomButton color={"#4CAF50"} bgColor={"#E8F5E9"}>
            Included
          </CustomButton>
        );
      case "Required":
        return (
          <CustomButton color={"#FF9800"} bgColor={"#FFF2DF"}>
            Required
          </CustomButton>
        );
      case "Recommended":
        return (
          <CustomButton color={"#6A7AB5"} bgColor={"#ECF0FF"}>
            Recommended
          </CustomButton>
        );
    }
  };
  
  const navigateToSpecificRoute = (data: RelatedAddOnsGridModel) => {
    if (!rolesAndPermissionStore.hasManagePermission("Edit")) return;
    const route = `/app/${data.type?.toLowerCase()}/detail/${data.id}`;
    navigate(route);
  };

  const headers = () => {
    const columns: ITableHeaders<RelatedAddOnsGridModel>[] = [
      {
        dataKey: "title",
        title: "",
        onCellRender: (data: RelatedAddOnsGridModel) => {
          return getTitle(data.title);
        },
      },
      {
        dataKey: "name",
        title: "Item Name",
        onCellRender: (data: RelatedAddOnsGridModel) => {
          return data.name;
        },
      },
      {
        dataKey: "itemCount",
        title: "Items",
        onCellRender: (data: RelatedAddOnsGridModel) => {
          return data.itemCount;
        },
      },
      {
        dataKey: "amount",
        title: "Amount",
        onCellRender: (data: RelatedAddOnsGridModel) => {
          return data.amount;
        },
      },
      {
        dataKey: "recurringPrice",
        title: "Recurring",
        onCellRender: (data: RelatedAddOnsGridModel) => {
          return data.recurringPrice;
        },
      },
      {
        dataKey: "recurringPrice",
        title: "Actions",
        className: "table-col-10 text-center",
        cellClassName: "table-col-10 text-center",
        onCellRender: (data: RelatedAddOnsGridModel) => {
          return (
            <div>
              <img
                src={EditIcon}
                className="img-15 clickable"
                onClick={() => navigateToSpecificRoute(data)}
              />
            </div>
          );
        },
      },
    ];
    return columns;
  };

  if (items.length == 0)
    return (
      <PlaceholderSmallerGrid
        title="No Add-Ons"
        icon={ItemsIcon}
        buttonCaption="New"
        disableButton={true}
      />
    );

  return (
    <TableGrid
      wrapperClassName="table-with-header-btns"
      tableHeader={
        <TableWithHeaderButtons
          isShowHeaderButton={false}
          totalItems={items.length}
          icon={ItemsIcon}
          title="Add-Ons"
        />
      }
      cellSpacing={20}
      headers={headers()}
      data={items}
      totalItemCount={items.length}
    />
  );
};

export default withRouter(RelatedAddOnsGrid);
